var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "16",
        viewBox: "0 0 20 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2.5 1.98047C2.15625 1.98047 1.875 2.27754 1.875 2.64063V3.55247L8.61328 9.39485C9.42188 10.0963 10.582 10.0963 11.3906 9.39485L18.125 3.55247V2.64063C18.125 2.27754 17.8438 1.98047 17.5 1.98047H2.5ZM1.875 6.1147V13.2031C1.875 13.5662 2.15625 13.8633 2.5 13.8633H17.5C17.8438 13.8633 18.125 13.5662 18.125 13.2031V6.1147L12.5781 10.9256C11.0781 12.2253 8.91797 12.2253 7.42188 10.9256L1.875 6.1147ZM0 2.64063C0 1.18416 1.12109 3.8147e-06 2.5 3.8147e-06H17.5C18.8789 3.8147e-06 20 1.18416 20 2.64063V13.2031C20 14.6596 18.8789 15.8438 17.5 15.8438H2.5C1.12109 15.8438 0 14.6596 0 13.2031V2.64063Z",
          fill: "#1A7BEE",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }